export default function Media() {
  return (
    <section id="media" className="py-16 md:py-20 px-4 md:px-6 bg-background-950">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex items-center gap-3 mb-10">
          <div className="w-1 h-7 bg-primary-500 rounded-full"></div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50">精彩预告</h2>
          <span className="text-xs text-foreground-500 bg-background-800/70 px-3 py-1 rounded-full">热播推荐</span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="group relative rounded-2xl overflow-hidden bg-background-800/40 border border-background-700/20 hover:border-accent-500/30 transition-all cursor-pointer">
            <div className="relative aspect-video overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20scene%20with%20imperial%20palace%20interior%2C%20dramatic%20lighting%2C%20warriors%20in%20traditional%20armor%2C%20cinematic%20composition%2C%20warm%20amber%20tones%2C%20epic%20atmosphere&width=800&height=450&seq=media-1&orientation=landscape"
                alt="庆余年2"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/80 via-transparent to-transparent"></div>
              <div className="absolute bottom-3 left-3 right-3 flex items-center justify-between">
                <span className="text-xs text-foreground-200 bg-background-950/70 px-2.5 py-1 rounded-full backdrop-blur-sm">全36集</span>
                <div className="w-10 h-10 rounded-full bg-primary-500/90 flex items-center justify-center group-hover:bg-primary-500 transition-colors">
                  <i className="ri-play-fill text-background-950 text-lg ml-0.5"></i>
                </div>
              </div>
            </div>
            <div className="p-4">
              <h3 className="font-heading text-lg font-bold text-foreground-100 group-hover:text-accent-400 transition-colors">庆余年2</h3>
              <p className="text-sm text-foreground-500 mt-1">范闲归来 京都风云再起</p>
              <div className="flex flex-wrap gap-2 mt-3">
                <span className="text-xs text-accent-400 bg-accent-500/10 px-2.5 py-1 rounded-full">古装</span>
                <span className="text-xs text-accent-400 bg-accent-500/10 px-2.5 py-1 rounded-full">权谋</span>
                <span className="text-xs text-accent-400 bg-accent-500/10 px-2.5 py-1 rounded-full">热播</span>
              </div>
            </div>
          </div>

          <div className="group relative rounded-2xl overflow-hidden bg-background-800/40 border border-background-700/20 hover:border-accent-500/30 transition-all cursor-pointer">
            <div className="relative aspect-video overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Mysterious%20ancient%20Chinese%20western%20region%20landscape%20with%20desert%20and%20caravan%2C%20detective%20theme%2C%20cinematic%20warm%20golden%20sunset%20lighting%2C%20suspenseful%20atmosphere%2C%20dramatic%20shadows&width=800&height=450&seq=media-2&orientation=landscape"
                alt="唐朝诡事录之西行"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/80 via-transparent to-transparent"></div>
              <div className="absolute bottom-3 left-3 right-3 flex items-center justify-between">
                <span className="text-xs text-foreground-200 bg-background-950/70 px-2.5 py-1 rounded-full backdrop-blur-sm">全40集</span>
                <div className="w-10 h-10 rounded-full bg-primary-500/90 flex items-center justify-center group-hover:bg-primary-500 transition-colors">
                  <i className="ri-play-fill text-background-950 text-lg ml-0.5"></i>
                </div>
              </div>
            </div>
            <div className="p-4">
              <h3 className="font-heading text-lg font-bold text-foreground-100 group-hover:text-accent-400 transition-colors">唐朝诡事录之西行</h3>
              <p className="text-sm text-foreground-500 mt-1">西域迷踪 惊险探案之旅</p>
              <div className="flex flex-wrap gap-2 mt-3">
                <span className="text-xs text-accent-400 bg-accent-500/10 px-2.5 py-1 rounded-full">悬疑</span>
                <span className="text-xs text-accent-400 bg-accent-500/10 px-2.5 py-1 rounded-full">探案</span>
                <span className="text-xs text-accent-400 bg-accent-500/10 px-2.5 py-1 rounded-full">热播</span>
              </div>
            </div>
          </div>

          <div className="group relative rounded-2xl overflow-hidden bg-background-800/40 border border-background-700/20 hover:border-accent-500/30 transition-all cursor-pointer">
            <div className="relative aspect-video overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Romantic%20Chinese%20period%20drama%20scene%20with%20rain%20and%20traditional%20architecture%2C%20emotional%20moment%20between%20characters%2C%20cinematic%20moody%20lighting%2C%20dark%20atmospheric%20tones%20with%20soft%20highlights&width=800&height=450&seq=media-3&orientation=landscape"
                alt="墨雨云间"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/80 via-transparent to-transparent"></div>
              <div className="absolute bottom-3 left-3 right-3 flex items-center justify-between">
                <span className="text-xs text-foreground-200 bg-background-950/70 px-2.5 py-1 rounded-full backdrop-blur-sm">全40集</span>
                <div className="w-10 h-10 rounded-full bg-primary-500/90 flex items-center justify-center group-hover:bg-primary-500 transition-colors">
                  <i className="ri-play-fill text-background-950 text-lg ml-0.5"></i>
                </div>
              </div>
            </div>
            <div className="p-4">
              <h3 className="font-heading text-lg font-bold text-foreground-100 group-hover:text-accent-400 transition-colors">墨雨云间</h3>
              <p className="text-sm text-foreground-500 mt-1">权谋爱情 极致虐心大剧</p>
              <div className="flex flex-wrap gap-2 mt-3">
                <span className="text-xs text-accent-400 bg-accent-500/10 px-2.5 py-1 rounded-full">爱情</span>
                <span className="text-xs text-accent-400 bg-accent-500/10 px-2.5 py-1 rounded-full">权谋</span>
                <span className="text-xs text-accent-400 bg-accent-500/10 px-2.5 py-1 rounded-full">新剧</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}